import { render, staticRenderFns } from "./Botonera.vue?vue&type=template&id=9868f5f0"
import script from "./Botonera.vue?vue&type=script&lang=js"
export * from "./Botonera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports